(function() {
  window.RS = window.RS || {};
  window.RS.helpers = window.RS.helpers || {};
  
  // js/helper/currency.js
  window.RS.helpers.formatMoney = function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.theme.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  window.RS.Tracking = (function() {
    const Tracking = {};
    Tracking.events = {
      AMAZON_LINK_CLICKS: 'amazon link clicks',
      FB_AMAZON_CLICK: 'amazonClick'
    };

    Tracking.trackAmazonLinkClicks = (e) => {
      if (e && e.detail) {
        const {
          product,
          eventCategory,
        } = e.detail;

        if (window.ga && product) {
          window.ga('send', {
            hitType: 'event',
            eventCategory: eventCategory || '',
            eventAction: AMAZON_LINK_CLICKS,
            eventLabel: product
          });
        }
      }
    }

    Tracking.trackFbAmazonClicks = (e) => {
      if (e && e.detail) {
        const {
          product
        } = e.detail;

        if (window.fbq && product) {
          window.fbq('track', FB_AMAZON_CLICK, product)
        }
      }
    }

    return Tracking;

  })();
})();